import { render, staticRenderFns } from "./CRMHome.vue?vue&type=template&id=0b4db600&scoped=true&"
import script from "./CRMHome.vue?vue&type=script&lang=js&"
export * from "./CRMHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4db600",
  null
  
)

export default component.exports